module.exports = __webpack_public_path__ + "static/media/inf_35og58.e7fc3d95.mp3";